import React from "react";
import { Row, Col, Table, Empty, Button } from "antd";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import LoaderGif from "../../assets/images/ie_loader.gif";

// const columns = [
//   {
//     title: "NAME",
//     dataIndex: "name",
//     align: "left",
//     sorter: {
//       compare: (a, b) => a.name - b.name,
//       multiple: 2,
//     },
//   },
//   {
//     title: "EMAIL ADDRESS",
//     dataIndex: "email",
//     align: "left",
//     sorter: {
//       compare: (a, b) => a.email - b.email,
//       multiple: 3,
//     },
//   },
//   {
//     title: "ACTION",
//     dataIndex: "action",
//     align: "left",
//   },
//   {
//     title: "ACTION",
//     dataIndex: "action",
//     align: "left",
//   },

//   {
//     title: "ACTION",
//     dataIndex: "action",
//     align: "left",
//   },
// ];

// const data = [
//   {
//     key: "1",
//     name: "John Brown",
//     email: "zain@yopmail.com",
//     action: "ALLOW",
//   },
//   {
//     key: "2",
//     name: "Jim Green",
//     email: "zain@yopmail.com",
//     action: "ALLOW",
//   },
//   {
//     key: "3",
//     name: "Joe Black",
//     email: "zain@yopmail.com",
//     action: "ALLOW",
//   },
//   {
//     key: "4",
//     name: "Jim Red",
//     email: "zain@yopmail.com",
//     action: "ALLOW",
//   },
//   {
//     key: "5",
//     name: "Jim Red",
//     email: "zain@yopmail.com",
//     action: "ALLOW",
//   },
//   {
//     key: "6",
//     name: "Jim Red",
//     email: "zain@yopmail.com",
//     action: "ALLOW",
//   },
// ];

// function onChange(pagination, filters, sorter, extra) {
//
// }

const TableWrapper = ({
  tableData,
  tableColumns,
  onHandleChange,
  previousPage,
  currentPage,
  metaData,
  isLoader,
  allowedAccountLoading,
  fromOrder,
  sorter
}) => {
  return (
    <Row gutter={[0, 20]}>
      <Col justify="start" xs={24} sm={24} md={24} lg={24} xl={24}>
        {tableData?.length ? (
          <Table
            // ant-table-column-sorter ant-table-column-sorter-full
            columns={tableColumns}
            dataSource={tableData}
            onChange={onHandleChange}
            pagination={false}
            className="ant-table-tbod"
          />
        ) : (
          <>
            {isLoader && <img src={LoaderGif} height={"60"} width={"60"} />}
            {!isLoader && <Empty description={"Nothing to show right now."} />}
          </>
        )}

        {/* <Table
          columns={columns}
          dataSource={data}
          onChange={onChange}
          pagination={false}
          className="ant-table-tbod"
        /> */}
      </Col>
      {Boolean(tableData?.length) && (
        <Col xs={24} sm={24} md={23} lg={23} xl={23}>
          <Row
            gutter={[5, 0]}
            xs={24}
            sm={24}
            md={23}
            lg={23}
            xl={23}
            justify={fromOrder ? "start" : "end"}
          >
            <Col className="tablePagination">
              {`Displaying ${metaData?.currentCount} of ${metaData?.totalCount}`}
              <Button
                type="link"
                icon={<BsChevronLeft color="#686868" size={15} />}
                onClick={previousPage}
                disabled={metaData?.page === 1}
              />
              {/* For  Showing Page-No */}
              {metaData?.page}
              <Button
                type="link"
                icon={<BsChevronRight color="#686868" size={15} />}
                onClick={currentPage}
                disabled={metaData?.total_pages === metaData?.page}
              />
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default TableWrapper;
